import {
  Ryecon,
  RyeconAccount,
  RyeconDatabase,
  RyeconDatabaseSchema,
  RyeconHelp,
  RyeconTable,
  RyeconTableView,
} from '@dbt-labs/sourdough';

import { WarehouseEntityType } from '@/__generated__/graphql';

export const entityToIconMap: Record<WarehouseEntityType | 'unknown', Ryecon> = {
  [WarehouseEntityType.Connection]: RyeconAccount,
  [WarehouseEntityType.Database]: RyeconDatabase,
  [WarehouseEntityType.Schema]: RyeconDatabaseSchema,
  [WarehouseEntityType.Table]: RyeconTable,
  [WarehouseEntityType.View]: RyeconTableView,
  unknown: RyeconHelp,
};

export const pluralizedEntityNames: Record<WarehouseEntityType, string> = {
  [WarehouseEntityType.Connection]: 'connections',
  [WarehouseEntityType.Database]: 'databases',
  [WarehouseEntityType.Schema]: 'schemas',
  [WarehouseEntityType.Table]: 'tables',
  [WarehouseEntityType.View]: 'views',
};

export const pluralizedCapitalizedEntityNames: Record<WarehouseEntityType, string> = {
  [WarehouseEntityType.Connection]: 'Connections',
  [WarehouseEntityType.Database]: 'Databases',
  [WarehouseEntityType.Schema]: 'Schemas',
  [WarehouseEntityType.Table]: 'Tables',
  [WarehouseEntityType.View]: 'Views',
};
